import { effectiveSourceBpm } from './clipTiming';
const reversed = new WeakMap();
/** Reverse only the visible native segment; originals and other instances stay untouched. */
export function reverseClipBuffer(buffer, clip, bpm) {
  if(!buffer || !clip.reverse)return buffer;
  const unit=240/effectiveSourceBpm(clip,bpm);
  const start=Math.max(0,Math.round((clip.offset||0)*unit*buffer.sampleRate));
  const end=Math.min(buffer.length,start+Math.round(clip.bars*unit*buffer.sampleRate));
  const key=`${start}:${end}`;
  let entries=reversed.get(buffer);if(!entries){entries=new Map();reversed.set(buffer,entries);}
  if(entries.has(key))return entries.get(key);
  const output=new AudioBuffer({length:buffer.length,numberOfChannels:buffer.numberOfChannels,sampleRate:buffer.sampleRate});
  for(let channel=0;channel<buffer.numberOfChannels;channel++) {
    const input=buffer.getChannelData(channel),data=output.getChannelData(channel);data.set(input);
    for(let i=start;i<end;i++)data[i]=input[end-1-(i-start)];
  }
  // Bound edited variants per source; obsolete buffers can be collected with their original.
  if(entries.size>=8)entries.delete(entries.keys().next().value);
  entries.set(key,output);return output;
}
export function clipFadeLengths(clip,duration) {
  let fadeIn=Math.min(duration,Math.max(0,Number(clip.fade_in)||0)),fadeOut=Math.min(duration,Math.max(0,Number(clip.fade_out)||0));
  if(fadeIn+fadeOut>duration){const scale=duration/(fadeIn+fadeOut);fadeIn*=scale;fadeOut*=scale;}
  return {fadeIn,fadeOut};
}
/** Shared live/export envelope, including seek into a fade and loop-window boundaries. */
export function scheduleClipFades(param,clip,window,startAt,bpm) {
  const unit=240/effectiveSourceBpm(clip,bpm);
  const total=(clip.fadeEnvelope?.bars??clip.bars)*unit,elapsed=(window.elapsed||0)+(clip.fadeEnvelope?.offsetBars||0)*unit;
  const {fadeIn,fadeOut}=clipFadeLengths(clip,total);
  const gain=t=>Math.max(0,Math.min(1,fadeIn?t/fadeIn:1,fadeOut?(total-t)/fadeOut:1));
  const end=elapsed+window.duration;
  param.setValueAtTime(window.fadeIn?0:gain(elapsed),startAt);
  const points=new Set([elapsed,end]);
  if(fadeIn>elapsed&&fadeIn<end)points.add(fadeIn);
  if(total-fadeOut>elapsed&&total-fadeOut<end)points.add(total-fadeOut);
  const edge=Math.min(.005,window.duration/3);
  if(window.fadeIn)points.add(elapsed+edge);
  if(window.fadeOut)points.add(end-edge);
  for(const t of [...points].sort((a,b)=>a-b).slice(1))param.linearRampToValueAtTime(window.fadeOut&&t===end?0:gain(t),startAt+t-elapsed);
}
